import React from "react";
import { Modal } from "react-bootstrap";
import { Button, Table } from "../..";
import { data, columns } from "./config";

import { Title, Footer, TableWrapper } from "./BenchmarkTypesStyles";

type Props = {
  show: boolean;
  onClose: () => void;
};

const BenchmarkTypesModal: React.FC<Props> = ({ onClose, show }) => {
  return (
    <Modal
      show={show}
      onHide={onClose}
      size="lg"
      dialogClassName="benchmarkTypesModal"
    >
      <Modal.Body>
        <Title>Benchmark Types</Title>
        <TableWrapper>
          <Table data={data} columns={columns} />
        </TableWrapper>
        <Footer>
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={onClose}>
            OK
          </Button>
        </Footer>
      </Modal.Body>
    </Modal>
  );
};

export { BenchmarkTypesModal };
